import type { CustomerDto } from "mws-finance-ts-sdk";

export const getCustomerAdminPageLink = (customer: CustomerDto): string => {
  return `/customers/${customer.id}/details`;
};
